(ns frontend.view.grid.lp-reports-grid.sub
  (:require
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [re-frame.core :as rf]))

(def ref-fields
  [:lp-report/process-owners
   :lp-report/final-approver
   :lp-report/text-contributors
   :lp-report/text-approver
   :lp-report/data-contributors
   :lp-report/data-approver
   :lp-report-holding/text-contributors
   :lp-report-holding/text-approver
   :lp-report-holding/data-contributors
   :lp-report-holding/data-approver])

(defn coerce-refs
  [row fields]
  (merge row
         (->> fields
              (map (fn [f]
                     (let [v (get row f)]
                       [f
                        (if (:db/id v)
                          (:db/id v)
                          (map :db/id v))])))
              (into {}))))

(rf/reg-sub
 ::loading?
 (fn [db]
   (get-in db [::loading?])))

(rf/reg-sub
 ::reports
 (fn [db]
   (->> (get-in db [::reports])
        (map (fn [[fund report holding]]
               (-> (merge
                    fund
                    holding
                    report
                    {:row-id            (str (:db/id fund) "-" (:db/id report) "-" (:db/id holding))
                     :row-id-ext        (str (:db/id report) "-" (:db/id holding))
                     :fund-id           (:db/id fund)
                     :report-id         (:db/id report)
                     :holding-id        (:db/id holding)
                     :common/created-on (or (:common/created-on report)
                                            (:common/created-on fund)
                                            (:common/created-on holding))})
                   (coerce-refs ref-fields)))))))

(def cols-for-all
  [;;:row-id
   :fund/name
   :common/created-on
   :lp-report-separator
   :lp-report/title
   :lp-report/step
   :lp-report/template-type
  ])

(def owner-admin-columns
  [:lp-report/process-owners
   :lp-report/final-approver
   :lp-report/text-status
   :lp-report/text-contributors
   :lp-report/text-approver
   :lp-report/data-status
   :lp-report/data-contributors
   :lp-report/data-approver

   :lp-report-holding/name
   :lp-report-holding/template-type
   :lp-report-holding/text-status
   :lp-report-holding/text-contributors
   :lp-report-holding/text-approver
   :lp-report-holding/data-status
   :lp-report-holding/data-contributors
   :lp-report-holding/data-approver])

(def fund-text-columns
  [:lp-report/text-status
   :lp-report/text-contributors
   :lp-report/text-approver])


(def fund-data-columns
  [:lp-report/data-status
   :lp-report/data-contributors
   :lp-report/data-approver])

(def holding-text-columns
  [:lp-report-holding/name
   :lp-report-holding/template-type
   :lp-report-holding/text-status
   :lp-report-holding/text-contributors
   :lp-report-holding/text-approver])

(def holding-data-columns
  [:lp-report-holding/name
   :lp-report-holding/template-type
   :lp-report-holding/data-status
   :lp-report-holding/data-contributors
   :lp-report-holding/data-approver])

(rf/reg-sub
 ::report-columns
 (fn [db [_ account-id account-team-ids]]
   (->>
    (get-in db [::reports])
    (mapcat
     (fn [[fund report holding]]
       (->>
        (concat cols-for-all
                (when
                  (or (some #{account-id} (map :db/id (:lp-report/process-owners report)))
                      (some (set account-team-ids) (map :db/id (:fund/reporting-admins fund)))
                      (session/is-admin?))
                  owner-admin-columns)
                (when
                  (some #{account-id} (map :db/id (:lp-report/text-contributors report)))
                  fund-text-columns)
                (when
                  (= account-id (:db/id (:lp-report/text-approver report)))
                  fund-text-columns)
                (when
                  (some #{account-id} (map :db/id (:lp-report/data-contributors report)))
                  fund-data-columns)
                (when
                  (= account-id (:db/id (:lp-report/data-approver report)))
                  fund-data-columns)
                (when
                  (some #{account-id} (map :db/id (:lp-report-holding/text-contributors holding)))
                  holding-text-columns)
                (when
                  (= account-id (:db/id (:lp-report-holding/text-approver holding)))
                  holding-text-columns)
                (when
                  (some #{account-id} (map :db/id (:lp-report-holding/data-contributors holding)))
                  holding-data-columns)
                (when
                  (= account-id (:db/id (:lp-report-holding/data-approver holding)))
                  holding-data-columns)))))
    (distinct))))

(rf/reg-sub
 ::selected-columns
 (fn [db _]
   (get-in db [::selected-columns])))
